<a *ngIf="routerLinkDelagate" [routerLink]="routerLinkDelagate" [class.--black-on-mobile]="blackOnMobile" class="button">
  {{ text }} <i-feather name="arrow-right" class="button__icon"></i-feather>
</a>
<a *ngIf="!routerLinkDelagate" href="{{ href || null }}" [class.--black-on-mobile]="blackOnMobile" class="button">
  {{ text }} <i-feather name="arrow-right" class="button__icon"></i-feather>
</a>
